import { render, staticRenderFns } from "./RoundCheckbox.vue?vue&type=template&id=9f802a6c&scoped=true"
import script from "./RoundCheckbox.vue?vue&type=script&lang=js"
export * from "./RoundCheckbox.vue?vue&type=script&lang=js"
import style0 from "./RoundCheckbox.vue?vue&type=style&index=0&id=9f802a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f802a6c",
  null
  
)

export default component.exports